export default __webpack_public_path__ + "static/blue-sky-3e5941963f72c4cc04f891ad8259a430.svg";